import { render, staticRenderFns } from "./XhtmlField.vue?vue&type=template&id=62e73a0d"
import script from "./XhtmlField.vue?vue&type=script&lang=js"
export * from "./XhtmlField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports